import { FromBufferstockActionBase } from '../from-bufferstock-action.base';
import {
  BookingParams,
  BookingPosition,
  BookingResult,
  StockTargetType,
} from '../../types';

/**
 * Bufferstock-Quelle in der BufferstockOnly-Welt. Verfügbar sind nur die
 * geteilten Bufferstock-Richtungen (Bufferstock/Maschine/Müll/Verbrauch).
 */
export class BufferstockOnlyFromBufferstockAction extends FromBufferstockActionBase {
  /**
   * Routet die Buchung nach `targetType` auf die geteilten
   * Bufferstock-Richtungen; welt-fremde Ziele (KFZ/Auftrag) werden abgelehnt.
   *
   * @param position Zu buchende Position (article_id und amount)
   * @param params Buchungskontext, Adapter und stabile client_ids
   * @returns BookingResult der gewählten Richtung bzw. Fehler bei unzulässigem Ziel
   */
  public async execute(
    position: BookingPosition,
    params: BookingParams,
  ): Promise<BookingResult> {
    this.debugInfo('[from-bufferstock:bufferstock-only]', position, params);
    switch (params.context.booking.targetType) {
      case StockTargetType.BUFFERSTOCK:
        return this.toBufferstock(position, params);
      case StockTargetType.MACHINE:
        return this.toMachine(position, params);
      case StockTargetType.TRASH_BIN:
        return this.toTrashBin(position, params);
      case StockTargetType.CONSUMPTION_BIN:
        return this.toConsumptionBin(position, params);
      case StockTargetType.CAR:
        return this.failure(
          'Bufferstock → KFZ ist in der BufferstockOnly-Welt nicht verfügbar',
        );
      case StockTargetType.BUFFERSTOCK_DISPOSAL:
        return this.failure(
          'Bufferstock → BufferstockDisposal ist keine valide Direction',
        );
      default:
        return this.exhaustiveFailure(params.context.booking.targetType);
    }
  }
}
